<template>
    <div :id="containerId" />
</template>

<script setup lang="ts">
import type { BaseEmbedProps } from '~/components/BaseEmbed/BaseEmbed.types';

const props = defineProps<BaseEmbedProps>();

const urlPath = props.url?.split('buzzsprout.com')[1];
const playerId = urlPath?.match(/\/(\d+)-/)?.[1];
const containerId = `buzzsprout-player-${playerId}`;

onMounted(() => {
    if (!urlPath || !playerId) {
        return;
    }

    useHead({
        script: [
            {
                src: `https://www.buzzsprout.com${urlPath}.js?container_id=${containerId}&player=small`,
                type: 'text/javascript',
            },
        ],
    });
});
</script>
